import axiosInstance from './../providers/Axios';
import { changePassword } from '../config/paths';

/**
 *
 * @param payload
 * @return {AxiosPromise<any>}
 */
export const updatePassword = async (payload) => {
  return axiosInstance({
    url: `${changePassword}`,
    method: 'put',
    data: { payload },
  });
};
